__turbopack_context__.v({
  "active": "t-zOJG_active",
  "content": "t-zOJG_content",
  "corporateHead": "t-zOJG_corporateHead",
  "corporateSubtitle": "t-zOJG_corporateSubtitle",
  "cta": "t-zOJG_cta",
  "ctaContainer": "t-zOJG_ctaContainer",
  "error": "t-zOJG_error",
  "gradient": "t-zOJG_gradient",
  "gradientOverlay": "t-zOJG_gradientOverlay",
  "loader": "t-zOJG_loader",
  "loaderBlink": "t-zOJG_loaderBlink",
  "logo": "t-zOJG_logo",
  "magicModal": "t-zOJG_magicModal",
  "orgCollabTag": "t-zOJG_orgCollabTag",
  "partner": "t-zOJG_partner",
  "root": "t-zOJG_root",
  "secondary": "t-zOJG_secondary",
  "successContent": "t-zOJG_successContent",
});
